import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@nextui-org/react';
import { useState } from 'react';

interface Props {
  append: (data: any) => void;
  data: any;
  idDescriptionProduct: string;
  setIdDescriptionProduct: (id: string) => void;
  isOpen: boolean;
    onOpenChange: () => void;
}

export const ModalDescriptionOrderDetail = ({
  append,
  data,
  idDescriptionProduct,
  setIdDescriptionProduct,
    isOpen,
    onOpenChange
}: Props) => {

  const [description, setDescription] = useState('');

  const handlePressWithDescription = (index: any, productId: string) => {
    const product = data?.products[productId];
    append({
      id: productId,
      customId: productId,
      name: product?.name,
      price: product?.price,
      quantity: 1,
      description,
    });
    setDescription('');
    setIdDescriptionProduct('');
    onOpenChange();
  };

  return (
    <Modal isOpen={isOpen} placement="center" onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Descripcion</ModalHeader>
            <ModalBody>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Escribe una descripción..."
                className="w-full p-2 border rounded"
              />
            </ModalBody>
            <ModalFooter>
              <Button color="danger" variant="light" onPress={onClose}>
                Cerrar
              </Button>
              <Button
                color="success"
                onPress={() => handlePressWithDescription(0, idDescriptionProduct)}
              >
                Confirmar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
